module.exports = __webpack_public_path__ + "static/media/arrow_drop_up.537c6244.svg";